import { render, staticRenderFns } from "./MarinaMap.vue?vue&type=template&id=35d1ebdc"
import script from "./MarinaMap.vue?vue&type=script&lang=js"
export * from "./MarinaMap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports